export default [
  {
    sectionName: "Oceanografía",
    options: [
      {
        id: "cop-temp-global",
        optionName: "Temp Copernicus Global",
        optionType: "actionable",
        variable: "thetao",
        isUnplayable: true,
        fitBounds: false,
        mapResources: [
          {
            id: "cop-temp-global",
            sourceId: "copernicus",
            resourceType: "heatmap",
            url: "/TEMP-GLOBAL",
          },
        ],
      },
      {
        id: "cop-temp-angola",
        optionName: "Temp Copernicus Angola",
        subsetOf: "cop-temp-global",
        optionType: "actionable",
        variable: "thetao",
        isUnplayable: true,
        fitBounds: true,
        mapResources: [
          {
            id: "cop-temp-angola",
            sourceId: "copernicus",
            resourceType: "heatmap",
            url: "/TEMP-ANGOLA",
          },
        ],
      },
      {
        id: "pde-temp-GIB",
        optionName: "Temperatura PdE GIB",
        optionType: "actionable",
        variable: "temperature",
        fitBounds: true,
        mapResources: [
          {
            id: "pde-temp-gibreg",
            sourceId: "pde",
            resourceType: "heatmap",
            url: "/GIB-REG",
          },
        ],
      },
      {
        id: "pde-temp-ALM",
        optionName: "Temperatura PdE ALM",
        optionType: "actionable",
        variable: "temperature",
        fitBounds: true,
        mapResources: [
          {
            id: "pde-temp-gibreg",
            sourceId: "pde",
            resourceType: "heatmap",
            url: "/ALM-CST",
          },
        ],
      },

      {
        id: "pde-salinity-GIB",
        optionName: "Salinidad PdE GIB",
        optionType: "actionable",
        variable: "salinity",
        fitBounds: true,
        mapResources: [
          {
            id: "pde-salinity-gibreg",
            sourceId: "pde",
            resourceType: "heatmap",
            url: "/GIB-REG",
          },
        ],
      },

      {
        id: "pde-salinity-ALM",
        optionName: "Salinidad PdE ALM",
        optionType: "actionable",
        variable: "salinity",
        fitBounds: true,

        mapResources: [
          {
            id: "pde-salinity-alm",
            sourceId: "pde",
            resourceType: "heatmap",
            url: "/ALM-CST",
          },
        ],
      },
      {
        id: "pde-currents-GIB",
        optionName: "Corrientes PdE GIB",
        optionType: "actionable",
        variable: "currents",
        fitBounds: true,

        mapResources: [
          {
            id: "pde-currents-GIB",
            sourceId: "pde",
            resourceType: "heatmap",
            url: "/GIB-REG",
          },
        ],
      },
      {
        id: "pde-currents-particles",
        optionName: "Particulas Corrientes GIB",
        optionType: "actionable",
        variable: "currents",
        mapResources: [
          {
            id: "pde-currents-particles-GIB",
            sourceId: "pde",
            resourceType: "particles",
            url: "/GIB-REG",
          },
        ],
      },
      {
        id: "pde-currents-ALM",
        optionName: "Corrientes PdE ALM",
        optionType: "actionable",
        variable: "currents",
        fitBounds: true,

        mapResources: [
          {
            id: "pde-currents-alm",
            sourceId: "pde",
            resourceType: "heatmap",
            url: "/ALM-CST",
          },
        ],
      },
      {
        id: "pde-tiles-currents-gib",
        optionName: "Corrientes Tiles GIB",
        optionType: "actionable",
        variable: "currents",
        fitBounds: true,
        mapResources: [
          {
            id: "pde-tiles-currents-gib",
            sourceId: "pde",
            resourceType: "tilemap",
            url: "/EST-CURR",
          },
        ],
      },
      {
        id: "pde-tiles-currents-ibi",
        optionName: "Corrientes Tiles IBI",
        optionType: "actionable",
        variable: "currents",
        fitBounds: true,

        mapResources: [
          {
            id: "pde-tiles-currents-ibi",
            sourceId: "pde",
            resourceType: "tilemap",
            url: "/IBI-LARGE",
          },
        ],
      },
      // {
      //   id: "pde-currents-particles",
      //   optionName: "Particulas Corrientes GIB",
      //   optionType: "actionable",
      //   variable: "currents",
      //   mapResources: [
      //     {
      //       id: "pde-currents-particles-GIB",
      //       sourceId: "pde",
      //       resourceType: "particles",
      //       url: "/GIB-REG",
      //     },
      //   ],
      // },

      {
        optionName: "Dispositivos Southtek",
        optionType: "dropdown",
        options: [
          {
            id: "boyas-eulerianas",
            optionName: "Boyas Eulerianas",
            optionType: "actionable",
            icon: "boya_euleriana",
            mapResources: [
              {
                sourceId: "southtek",
                resourceType: "sensor",
                url: "/boyas-eulerianas",
              },
            ],
          },
          {
            id: "boyas-moviles",
            optionName: "Boyas Lagrangianas",
            optionType: "actionable",
            icon: "boya_lagrangniana",
            mapResources: [
              {
                sourceId: "southtek",
                resourceType: "sensor",
                url: "/boyas-Lagrangianas",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    sectionName: "Biología",
    options: [
      {
        id: "nasa-bio-0",
        optionName: "Bioclimate 1",
        optionType: "actionable",
        variable: "bio",
        isUnplayable: true,
        fitBounds: true,

        mapResources: [
          {
            id: "cop-bio-0",
            sourceId: "nasa",
            resourceType: "heatmap",
            url: "/CHELSA-BIO-0",
          },
        ],
      },
      {
        id: "nasa-bio-1",
        optionName: "Bioclimate 2",
        optionType: "actionable",
        variable: "bio",
        isUnplayable: true,
        fitBounds: true,

        mapResources: [
          {
            id: "cop-bio-1",
            sourceId: "nasa",
            resourceType: "heatmap",
            url: "/CHELSA-BIO-1",
          },
        ],
      },
    ],
  },
  {
    sectionName: "Geología",
    options: [
      {
        optionName: "Estratos Angola",
        optionType: "dropdown",
        options: [
          {
            id: "IGEO-coast-units",
            optionName: "Costa - Unidades",
            optionType: "actionable",
            variable: "geological",
            sourceId: "IGEO",
            resourceType: "feature",
            mapResources: [
              {
                id: "IGEO-coast-units",
                sourceId: "igeo",
                resourceType: "geojson",
                url: "/ANG-GEO-Units",
              },
            ],
          },
          {
            id: "IGEO-coast-structures",
            optionName: "Costa - Estructuras",
            optionType: "actionable",
            variable: "geological",
            sourceId: "IGEO",
            resourceType: "feature",
            mapResources: [
              {
                id: "IGEO-coast-structures",
                sourceId: "igeo",
                resourceType: "geojson",
                url: "/ANG-GEO-Structures",
              },
            ],
          },
        ],
      },
    ],
  },
];
